export default __webpack_public_path__ + "static/media/key1.bf3bc4f9.png";